// src/components/NominationsTable.jsx
import React, { useState } from 'react';

// Полный массив номинаций с «всем текстом», без пропусков
const nominations = [
  {
    number: '1',
    title: 'BrandGlobe Mastermind Grand Prix',
    subtitle: '(Главная награда лидера‑визионера)',
    description: (
      <>
        <p>
          Вручается команде, чьим драйвером выступает лидер‑стратег, сумевший вывести цифровой бренд на уровень международной экосистемы.
        </p>
        <p>Жюри оценивает, насколько капитан:</p>
        <ul>
          <li>сформировал цельную кросс‑функциональную команду,</li>
          <li>заложил чёткую архитектуру бренда,</li>
          <li>продемонстрировал план масштабирования в трёх и более странах.</li>
        </ul>
        <p>
          Личная презентация капитана учитывается в финальном питче и даёт до 20 % бонусных баллов.
        </p>
        <p>
          <strong>Приз:</strong> кубок BrandGlobe, $10 000 на медиазапуск и персональное менторство с CEO МАМИ.
        </p>
      </>
    )
  },
  {
    number: '2',
    title: 'Cross‑Cultural Navigator Award',
    subtitle: '(Лидер культурной адаптации)',
    description: (
      <>
        <p>
          Отмечает капитана, который показал высший пилотаж в управлении мультикультурной креативной командой и доказал,
          что бренд способен органично «зазвучать» в разных культурных кодах.
        </p>
        <p>Критерии:</p>
        <ul>
          <li>глубина локальных инсайтов (исследование рынков СНГ, ЕС и за их пределами),</li>
          <li>гибкая контент‑стратегия,</li>
          <li>корректная работа с языковыми/визуальными нюансами.</li>
        </ul>
        <p>
          30 % общей оценки — личные soft‑skills лидера: способность фасилитировать диалог, предотвращать конфликты и вдохновлять команду.
        </p>
        <p>
          <strong>Приз:</strong> грант на локализацию кампании в трёх рынках и годовое членство капитана в Cross‑Cultural Marketing Guild.
        </p>
      </>
    )
  },
  {
    number: '3',
    title: 'Digital Innovation Trailblazer',
    subtitle: '*(Лидер технологического прорыва)*',
    description: (
      <>
        <p>
          Предназначена для капитана, который внедрил в проект передовые digital‑инструменты (AI‑генерация, AR/VR,
          блокчейн‑программы лояльности) и доказал реальную бизнес‑ценность инноваций.
        </p>
        <p>Оценивается:</p>
        <ul>
          <li>технологическая новизна,</li>
          <li>связка «технология — бренд‑ценность»,</li>
          <li>roadmap внедрения и способность лидера управлять tech‑рисками.</li>
        </ul>
        <p>
          Отдельно начисляются баллы за доступность MVP и открытый репозиторий.
        </p>
        <p>
          <strong>Приз:</strong> облачный грант, подписка на премиум‑SaaS и приглашение капитана выступить спикером на BrandGlobe Summit.
        </p>
      </>
    )
  },
  {
    number: '4',
    title: 'Global Vision Grand Prix',
    subtitle: '(Главная командная награда)',
    description: (
      <>
        <p>
          Присуждается команде, разработавшей наиболее целостный и масштабируемый цифровой бренд, одинаково
          убедительно работающий как минимум в трёх странах.
        </p>
        <p>Жюри оценивает:</p>
        <ul>
          <li>стратегическую проработку позиционирования,</li>
          <li>универсальность визуальной айдентики,</li>
          <li>финансовую модель и план глобального масштабирования.</li>
        </ul>
        <p>
          <strong>Приз:</strong> кубок BrandGlobe, $10 000 на медиа‑запуск и приоритетное место в акселераторе МАМИ.
        </p>
      </>
    )
  },
  {
    number: '5',
    title: 'Culture Fusion Award',
    subtitle: '(Лучшая культурная адаптация)',
    description: (
      <>
        <p>
          Номинация для проекта, который тонко интегрирует локальные ценности, язык и визуальный код каждой целевой
          культуры, не теряя цельности бренда.
        </p>
        <p>Ключевые критерии:</p>
        <ul>
          <li>исследование культурного контекста,</li>
          <li>смысловая/языковая гибкость слогана,</li>
          <li>вариативная цветовая палитра,</li>
          <li>корректность использования локальных инсайтов (humor, традиции, табу).</li>
        </ul>
        <p>
          Эксперты‑этнографы и copy‑консультанты дают отдельные оценки за «чувствительность» бренда.
        </p>
      </>
    )
  },
  {
    number: '6',
    title: 'Digital Innovation in Branding',
    subtitle: '(Лучшая технологическая новация)',
    description: (
      <>
        <p>
          Присуждается команде, чья бренд‑идея использует передовые цифровые инструменты: AR‑фильтры, генеративный AI‑контент,
          блокчейн‑программы лояльности, интерактивные WebXR‑витрины и прочие frontier‑технологии.
        </p>
        <p>
          Важна не только технологическая «вау‑фича», но и то, как она усиливает ценность бренда и повышает
          вовлечённость аудитории.
        </p>
        <p>
          <strong>Приз:</strong> грант на облачную инфраструктуру и годовая подписка на партнёрские SaaS‑сервисы.
        </p>
      </>
    )
  },
  {
    number: '7',
    title: 'Tech Disruptor Brand',
    subtitle: '(Лучший бренд технологического продукта)',
    description: (
      <>
        <p>
          Для команд, создающих B2C‑ либо B2B‑ технопродукты (SaaS, IoT, гаджеты). Оценивается:
        </p>
        <ul>
          <li>
            уникальность решения, понятность УТП, UX‑концепт, roadmap вывода на рынок и стратегия комьюнити‑построения.
          </li>
        </ul>
        <p>
          Бонус‑баллы начисляются за open‑source‑подход и доступность MVP в публичном репозитории.
        </p>
        <p>
          <strong>Приз:</strong> консультационный пакет от венчурных партнёров и лицензия на инструмент product analytics.
        </p>
      </>
    )
  },
  {
    number: '8',
    title: 'Fashion & Lifestyle Icon',
    subtitle: '(Лучшая fashion‑ или lifestyle‑концепция)',
    description: (
      <>
        <p>
          Данная номинация охватывает бренды одежды, аксессуаров, косметики, wellness‑продуктов. Фокус — эмоциональная
          история бренда, визуальный сторителлинг, стратегия инфлюенсер‑коллабораций и экологичность цепочки поставок (sustainable fashion).
        </p>
        <p>Оценка включает:</p>
        <ul>
          <li>virtual‑try‑on‑опыт и omni‑канальность продажи (маркетплейсы, соцсети, live‑коммерция).</li>
        </ul>
        <p>
          <strong>Приз:</strong> фотосессия для lookbook и годовой PR‑пакет в fashion‑медиа СНГ и ЕС.
        </p>
      </>
    )
  },
  {
    number: '9',
    title: 'Social Impact Champion',
    subtitle: '(Лучшая социальная инициатива)',
    description: (
      <>
        <p>
          Для проектов, решающих общественные и экологические задачи — от инклюзивных сервисов до платформ донорства.
        </p>
        <p>Главные параметры:</p>
        <ul>
          <li>ясность проблемы, измеримый KPI воздействия, финансовая устойчивость, партнёрства с НКО/госорганами.</li>
        </ul>
        <p>
          Отдельно оценивается прозрачность отчётности (impact reporting) и план масштабирования решения в другие регионы.
        </p>
        <p>
          <strong>Приз:</strong> грант на рекламу в соцсетях и менторскую поддержку Impact‑фонда.
        </p>
      </>
    )
  },
  {
    number: '10',
    title: 'Audience Choice Award',
    subtitle: '(Приз зрительских симпатий)',
    description: (
      <>
        <p>
          Единственная номинация, где финальный результат решается открытым онлайн‑голосованием зрителей платформы и
          партнёрских медиа.
        </p>
        <p>
          В отбор попадают 10 проектов с суммарным баллом жюри ≥ 70. Команды готовят минутный видеопитч; просмотры и лайки
          конвертируются в голоса через проверяемый блокчейн‑счётчик.
        </p>
        <p>
          <strong>Приз:</strong> сертификаты на образовательные курсы МАМИ и медиа‑поддержка анонса бренда в соцсетях организатора.
        </p>
      </>
    )
  }
];


const NominationsTable = () => {
  const [expanded, setExpanded] = useState(false);

  // показываем либо только первую, либо все
  const visibleRows = expanded ? nominations : nominations.slice(0, 1);

  return (
    <section id='nominations' className="nominations">
      <div className="container">
        <h2 className="nominations__heading">Номинации BrandGlobe Hackathon</h2>
        <table className="nominations__table">
          <thead>
            <tr>
              <th>№</th>
              <th>Номинация</th>
              <th>Подробное описание</th>
            </tr>
          </thead>
          <tbody>
            {visibleRows.map(({ number, title, subtitle, description }, idx) => (
              <tr
                key={number}
                className={expanded && idx > 0 ? 'fade-in' : ''}
              >
                <td>{number}</td>
                <td>
                  <div className="nominations__title">{title}</div>
                  <div className="nominations__subtitle">{subtitle}</div>
                </td>
                <td>{description}</td>
              </tr>
            ))}
          </tbody>
        </table>

        <button
          className="nominations__show-btn"
          onClick={() => setExpanded(e => !e)}
        >
          {expanded ? 'Скрыть все номинации ▲' : 'Показать все номинации ▼'}
        </button>
      </div>
    </section>
  );
};

export default NominationsTable;